import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=04257231"
import script from "./forgot-password.ts?vue&type=script&lang=js&external"
export * from "./forgot-password.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports